var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmDialog',{attrs:{"title":`Delete Photo ${_vm.photo.id}?`,"message":`Are you sure you want to delete ${_vm.photo.original_filename}?`,"loading":_vm.deleting,"color":"delete","small":""},on:{"confirm":function($event){return _vm.deletePhoto(_vm.photo)}}},[_c('VIcon',{attrs:{"small":""}},[_vm._v(" mdi-delete ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }